export class ResolutionDate {
    private static MILLISECONDS_IN_DAY: number = 1000 * 60 * 60 * 24;

    public static getDateFromDays(days: number): Date {
        days = Math.floor(days);
        return new Date(days * ResolutionDate.MILLISECONDS_IN_DAY);
    }

    public static getDateStringFromDays(days: number, useShortFormat: boolean = false): string {
        // console.warn('ResolutionDate.getDateStringFromDays: ', days);
        if (typeof days !== 'number') {
            console.warn('ResolutionDate.getDateStringFromDays: days is not a number', days);
            return useShortFormat ? '1970-12-12' : this.getShortFormat(new Date());
        }
        if (useShortFormat) {
            // return in format '30-12'
            let date = this.getDateFromDays(days);
            return this.getShortFormat(date);
        } else {
            try {
                return this.getDateFromDays(days).toISOString().substring(0, 10);
            } catch (e) {
                console.warn(
                    'ResolutionDate.getDateStringFromDays: ',
                    this.getDateFromDays(days),
                    days
                );
                return '1970-12-12';
            }
        }
    }

    public static getDaysFromDate(date: Date): number {
        date.setHours(12, 0, 0, 0);
        let offset = new Date().getTimezoneOffset();
        return Math.floor(date.getTime() / ResolutionDate.MILLISECONDS_IN_DAY - offset / 60 / 24);
    }

    public static getDaysForToday(): number {
        let date = new Date();
        date.setHours(12, 0, 0, 0);
        return this.getDaysFromDate(date);
    }

    public static getShortFormat(date: Date): string {
        let separator = '.';
        let day = date.getDate();
        let month = date.getMonth() + 1;
        return (day < 10 ? '' : '') + day + separator + (month < 10 ? '0' : '') + month;
    }
}
